export default __webpack_public_path__ + "static/media/menu.fc743db5.svg";